export default function createThunkMiddleware(args) {
  return function () {
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(args);
        }

        return next(action);
      };
    };
  };
}
//# sourceMappingURL=thunk-middleware.js.map